export function generatePaths(config, parentPath = "") {
    const result = { path: parentPath || undefined };
    for (const key in config) {
        const value = config[key];
        const currentPath = parentPath ? `${parentPath}.${key}` : key;
        if (value && typeof value === "object" && "value" in value) {
            result[key] = { path: currentPath };
        }
        else {
            result[key] = generatePaths(value, currentPath);
        }
    }
    return result;
}
//# sourceMappingURL=pathGenerator.js.map